import { SET_UNIQUE_YEARS, SET_SELECTED_YEARS, SET_RELATED_ENGAGEMENT, SET_ENGAGEMENT_TASK, SET_ENGAGEMENT_ID, SET_REFRESH, SET_LOADING } from "./TaskBudgetType.ts";
import { EngagementTaskHistory } from "../../Models/EngagementTaskHistory";

interface TaskBudgetState {
    uniqueYears: number[];
    selectedYears: number[];
    engagementId: string;
    relatedEngagement: { [key: number]: EngagementTaskHistory };
    engagementTask: EngagementTaskHistory;
    refresh: boolean;
    loading: boolean;
}

const initialState: TaskBudgetState = {
    engagementId: "",
    uniqueYears: [],
    selectedYears: [],
    relatedEngagement: {},
    engagementTask: {} as EngagementTaskHistory,
    refresh: false,
    loading: false,
};

const TaskBudgetReducer = (state = initialState, action: any): TaskBudgetState => {
    switch (action.type) {
        case SET_UNIQUE_YEARS:
            return { ...state, uniqueYears: action.payload };
        case SET_SELECTED_YEARS:
            return { ...state, selectedYears: action.payload };
        case SET_RELATED_ENGAGEMENT:
            return { ...state, relatedEngagement: action.payload };
        case SET_ENGAGEMENT_TASK:
            return { ...state, engagementTask: action.payload };
        case SET_ENGAGEMENT_ID:
            return { ...state, engagementId: action.payload };
        case SET_REFRESH:
            return { ...state, refresh: action.payload };
        case SET_LOADING:
            return { ...state, loading: action.payload };
        default:
            return state;
    }
};

export default TaskBudgetReducer;
